// Active offers for the first 5 items of each collection
export const activeOffers = {
  pudgypenguins: {
    '8422': [
      { price: '16.15', buyer: '0x7755...442f', expiration: '12h' },
      { price: '16.50', buyer: '0x9c4d...3e5D', expiration: '6h' },
      { price: '16.25', buyer: '0x5b2a...7f8A', expiration: '24h' }
    ],
    '407': [
      { price: '17.20', buyer: '0x3f8e...2c9B', expiration: '8h' },
      { price: '17.00', buyer: '0x1d4a...8b2D', expiration: '16h' }
    ],
    '3758': [
      { price: '16.75', buyer: '0x8b5f...9c3B', expiration: '4h' },
      { price: '16.40', buyer: '0x2c7d...6a4C', expiration: '18h' },
      { price: '16.15', buyer: '0x4e9a...D8b5', expiration: '10h' }
    ],
    '495': [
      { price: '17.50', buyer: '0x6b3e...D7f4', expiration: '14h' },
      { price: '17.25', buyer: '0x9f4d...E2a8', expiration: '22h' }
    ],
    '3934': [
      { price: '16.90', buyer: '0x2d8e...C9f7', expiration: '5h' },
      { price: '16.60', buyer: '0x5c7f...E8a4', expiration: '20h' }
    ]
  },
  azuki: {
    '301': [
      { price: '11.85', buyer: '0x4b9r...E7a5', expiration: '9h' },
      { price: '11.60', buyer: '0x7e2d...B8c6', expiration: '15h' },
      { price: '11.35', buyer: '0x1f8b...D9a3', expiration: '3h' }
    ],
    '5442': [
      { price: '12.10', buyer: '0x8d4e...F9c5', expiration: '7h' },
      { price: '11.90', buyer: '0x3a9f...E7b2', expiration: '19h' }
    ],
    '7102': [
      { price: '11.75', buyer: '0x6c2...D8a4', expiration: '11h' },
      { price: '11.45', buyer: '0x9b5...E2a8', expiration: '23h' }
    ],
    '469': [
      { price: '12.25', buyer: '0x2f8...E9a7', expiration: '13h' },
      { price: '12.00', buyer: '0x5a7...F8d4', expiration: '21h' },
      { price: '11.80', buyer: '0x8c4...E9b5', expiration: '4h' }
    ],
    '1565': [
      { price: '11.95', buyer: '0x1d7...E4a9', expiration: '17h' },
      { price: '11.70', buyer: '0x4e9...F8b5', expiration: '2h' }
    ]
  },
  doodles: {
    '2142': [
      { price: '6.85', buyer: '0x3b8d...E2a9', expiration: '8h' },
      { price: '6.60', buyer: '0x7f4e...D8a2', expiration: '16h' }
    ],
    '4623': [
      { price: '7.10', buyer: '0x2c9e...B8d4', expiration: '12h' },
      { price: '6.90', buyer: '0x5d8b...E2a9', expiration: '6h' },
      { price: '6.75', buyer: '0x8a4f...E9b5', expiration: '24h' }
    ],
    '7891': [
      { price: '6.95', buyer: '0x1f7c...D9a4', expiration: '4h' },
      { price: '6.70', buyer: '0x4e9a...B8d5', expiration: '18h' }
    ],
    '3456': [
      { price: '7.25', buyer: '0x6b3e...5E2a7', expiration: '10h' },
      { price: '7.00', buyer: '0x9f4e...D8a2', expiration: '22h' }
    ],
    '9928': [
      { price: '6.80', buyer: '0x2d8e...C9f7', expiration: '14h' },
      { price: '6.55', buyer: '0x5c7f...E8a4', expiration: '20h' },
      { price: '6.40', buyer: '0x8b4e...F9a5', expiration: '5h' }
    ]
  },
  'redacted-remilio-babies': {
    '9992': [
      { price: '6.85', buyer: '0x3b8d...E2a9', expiration: '8h' },
      { price: '6.60', buyer: '0x7f4e...D8a2', expiration: '16h' }
    ],
    '9982': [
      { price: '7.10', buyer: '0x2c9e...B8d4', expiration: '12h' },
      { price: '6.90', buyer: '0x5d8b...E2a9', expiration: '6h' },
      { price: '6.75', buyer: '0x8a4f...E9b5', expiration: '24h' }
    ]
  }
};
